module.exports = __webpack_public_path__ + "img/plus.eddcc44b.svg";